import axios from 'axios'
import { MessageBox } from 'element-ui'

// 记录当前版本
let currentVersion = null

// 添加一个变量来跟踪更新提示是否已经显示
let updateNotificationShown = false

// 创建并显示更新提示
function showUpdateNotification() {
  if (updateNotificationShown) {
    return // 如果已经显示过，则不再次显示
  }

  MessageBox.alert('版本已更新，请刷新页面。', '更新提示', {
    confirmButtonText: '确定',
    callback: () => {
      window.location.reload()
      updateNotificationShown = false
    }
  })
    .then(() => {
      // 确保在关闭弹窗后重置标志
      updateNotificationShown = false
    })
    .catch(() => {
      // 同样确保在取消关闭弹窗后重置标志
      updateNotificationShown = false
    })

  updateNotificationShown = true // 设置为 true，表示已经显示
}

async function checkVersionChange() {
  // 判断当前环境
  const env = process.env.VUE_APP_UTILS_ENV
  if (process.env.NODE_ENV !== 'production') return false
  if (env !== 'dev' && env !== 'test') {
    return false
  }

  try {
    const response = await axios.get(
      process.env.VUE_APP_EMI_API + `/web/v.json?t=${new Date().getTime()}`
    )
    const newVersion = response.data.hash
    // console.log('response ', response.data)

    // 检查版本是否发生变化
    if (currentVersion !== null && currentVersion !== newVersion) {
      showUpdateNotification()
    }

    // 更新当前版本
    currentVersion = newVersion
  } catch (error) {
    console.error('Error checking version:', error)
    return false
  }
}

// 每 10 秒检查一次版本
setInterval(() => {
  checkVersionChange()
}, 10000)
